import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaitofivejyotilingadarshan() {



    const cardData = {





keyword: "Navi Mumbai to 5 Jyotirlinga Darshan Cab",

headingDescription: "Shreesha Tours & Travels provides comfortable Navi Mumbai to 5 Jyotirlinga Darshan Cab Service for devotees planning a spiritual pilgrimage across Maharashtra's famous Jyotirlinga temples. We offer customized pilgrimage tour packages with chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles suitable for families and groups. With experienced drivers, clean vehicles, flexible travel schedules, transparent pricing, doorstep pickup, and 24/7 customer support, we ensure a safe, peaceful, and convenient religious journey. Whether you are planning a complete Jyotirlinga Yatra with family members or a customized temple tour, Shreesha Tours & Travels provides reliable cab services from Navi Mumbai for a comfortable pilgrimage experience.",

topPlaces: [
  {
    title: "Trimbakeshwar Jyotirlinga Nashik",
    description: "Trimbakeshwar Jyotirlinga Temple near Nashik is one of the twelve sacred Jyotirlingas of Lord Shiva and holds immense religious importance among devotees. The temple is famous for its unique architecture, spiritual atmosphere, and the origin of the Godavari River nearby. Visitors also explore Panchavati, Ramkund, Sita Gufa, and other Nashik attractions during their pilgrimage tour."
  },
  {
    title: "Bhimashankar Jyotirlinga Pune",
    description: "Bhimashankar Jyotirlinga Temple is located amidst the beautiful Sahyadri mountain ranges and dense forests of Pune district. It is not only a major pilgrimage destination but also a popular nature retreat known for wildlife sanctuary, trekking trails, waterfalls, and scenic landscapes. Devotees enjoy a peaceful spiritual experience surrounded by natural beauty."
  },
  {
    title: "Grishneshwar Jyotirlinga Aurangabad",
    description: "Grishneshwar Jyotirlinga Temple near Ellora Caves is one of the most revered Shiva temples in Maharashtra. The temple is known for its beautiful stone architecture, religious significance, and peaceful surroundings. Visitors often combine Grishneshwar Darshan with Ellora Caves, Daulatabad Fort, and Bibi Ka Maqbara sightseeing."
  },
  {
    title: "Aundha Nagnath Jyotirlinga Hingoli",
    description: "Aundha Nagnath Temple is an ancient Jyotirlinga shrine located in Maharashtra and holds great importance among Lord Shiva devotees. The temple is known for its historical significance, unique architecture, and spiritual atmosphere. Pilgrims visiting this temple experience traditional rituals and peaceful surroundings away from city crowds."
  },
  {
    title: "Parli Vaijnath Jyotirlinga Beed",
    description: "Parli Vaijnath Jyotirlinga Temple is one of the important Shiva pilgrimage destinations in Maharashtra and attracts devotees throughout the year. The temple is famous for its religious traditions, peaceful environment, and spiritual significance. Many devotees include Parli Vaijnath as part of their Maharashtra Jyotirlinga Yatra."
  },
  {
    title: "Shirdi Sai Baba Temple",
    description: "Shirdi is one of Maharashtra's most visited spiritual destinations and is often combined with Jyotirlinga tours. Devotees visit Sai Baba Samadhi Temple, Dwarkamai, Chavadi, and Lendi Baug for blessings and spiritual peace. A comfortable cab tour allows families and senior citizens to complete multiple religious destinations conveniently."
  },
  {
    title: "Shani Shingnapur Temple",
    description: "Shani Shingnapur is a famous religious village near Shirdi known for the temple of Lord Shani. The temple is unique because of its open-air shrine and strong belief among devotees. Travelers often add this destination to their Maharashtra pilgrimage route while visiting nearby spiritual attractions."
  },
  {
    title: "Ellora Caves Aurangabad",
    description: "Ellora Caves is a UNESCO World Heritage Site located near Grishneshwar Jyotirlinga and is famous for ancient Buddhist, Hindu, and Jain rock-cut monuments. The Kailasa Temple is the main attraction, showcasing incredible architecture and historical craftsmanship. It is an ideal sightseeing stop during a Jyotirlinga pilgrimage tour."
  },
  {
    title: "Panchavati Nashik",
    description: "Panchavati is an important religious area in Nashik associated with the Ramayana and known for Ramkund, Kalaram Temple, Sita Gufa, and other sacred places. Many devotees visiting Trimbakeshwar Jyotirlinga include Panchavati sightseeing as part of their spiritual journey."
  },
  {
    title: "Tuljapur Bhavani Temple",
    description: "Tuljapur Bhavani Temple is one of Maharashtra's most respected religious destinations dedicated to Goddess Bhavani. Located in Osmanabad district, the temple attracts devotees from across India. Many travelers combine Tuljapur Darshan with Jyotirlinga and other Maharashtra pilgrimage tours for a complete spiritual experience."
  }
],


"services": [
  {
    "name": "Navi Mumbai to 5 Jyotirlinga Darshan Cab",
    "description": "Book Navi Mumbai to 5 Jyotirlinga Darshan Cab for a comfortable and spiritual journey with experienced chauffeurs and well-maintained AC vehicles. Enjoy a hassle-free Maharashtra Jyotirlinga Yatra with options like Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and Tempo Traveller. Our private cab service is ideal for families, devotees, senior citizens, and groups looking for safe, flexible, and convenient temple travel."
  },
  {
    "name": "5 Jyotirlinga Darshan Cab from Navi Mumbai",
    "description": "Reserve 5 Jyotirlinga Darshan Cab from Navi Mumbai for a complete Lord Shiva pilgrimage experience with professional drivers, comfortable seating, and customized travel plans. Get reliable transportation for visiting multiple Jyotirlinga temples with flexible schedules, doorstep pickup, and smooth long-distance travel."
  },
  {
    "name": "Navi Mumbai 5 Jyotirlinga Yatra Cab",
    "description": "Choose Navi Mumbai 5 Jyotirlinga Yatra Cab for a peaceful religious tour with experienced chauffeurs and premium vehicles. Travel comfortably across Maharashtra Jyotirlinga destinations with clean AC cars, spacious seating, and reliable cab facilities designed for devotees and families."
  },
  {
    "name": "5 Jyotirlinga Tour Package Navi Mumbai by Cab",
    "description": "Book 5 Jyotirlinga Tour Package Navi Mumbai by Cab for a complete pilgrimage journey with planned routes, comfortable vehicles, and professional drivers. Enjoy customized multi-day Jyotirlinga Darshan packages with flexible pickup locations and convenient travel arrangements."
  },
  {
    "name": "Navi Mumbai to Jyotirlinga Darshan Taxi",
    "description": "Hire Navi Mumbai to Jyotirlinga Darshan Taxi for safe and comfortable temple travel with affordable pricing and experienced chauffeurs. Choose from multiple vehicle options for family trips, group tours, and devotional journeys."
  },
  {
    "name": "5 Jyotirlinga Darshan Yatra Cab",
    "description": "Book 5 Jyotirlinga Darshan Yatra Cab for a smooth and memorable Shiva pilgrimage. Enjoy comfortable rides, professional drivers, clean AC vehicles, and flexible travel plans for complete Jyotirlinga temple visits."
  },
  {
    "name": "Jyotirlinga Darshan Cab Service Navi Mumbai",
    "description": "Choose Jyotirlinga Darshan Cab Service Navi Mumbai for reliable religious tour transportation with experienced chauffeurs and well-maintained vehicles. Our cab services provide comfortable travel solutions for devotees visiting multiple Jyotirlinga temples."
  },
  {
    "name": "Maharashtra 5 Jyotirlinga Darshan Cab",
    "description": "Book Maharashtra 5 Jyotirlinga Darshan Cab for convenient pilgrimage travel across famous Shiva temples. Enjoy safe journeys with AC vehicles, professional drivers, flexible packages, and comfortable seating options for families and groups."
  },
  {
    "name": "Jyotirlinga Tour Cab from Navi Mumbai",
    "description": "Reserve Jyotirlinga Tour Cab from Navi Mumbai for a dedicated temple tour experience with private vehicles and expert chauffeurs. Travel comfortably with customized routes, multiple vehicle choices, and reliable service throughout your spiritual journey."
  },
  {
    "name": "Lord Shiva Jyotirlinga Darshan Cab",
    "description": "Book Lord Shiva Jyotirlinga Darshan Cab for a peaceful religious journey with comfortable transportation and professional driver support. Enjoy a convenient pilgrimage experience with safe travel and flexible booking options."
  },
  {
    "name": "AC Cab for 5 Jyotirlinga Darshan from Navi Mumbai",
    "description": "Hire AC Cab for 5 Jyotirlinga Darshan from Navi Mumbai for comfortable long-distance travel with fully air-conditioned vehicles. Enjoy smooth rides, clean interiors, experienced chauffeurs, and relaxing journeys during your Jyotirlinga Yatra."
  },
  {
    "name": "Round Trip Cab Navi Mumbai to Jyotirlinga",
    "description": "Book Round Trip Cab Navi Mumbai to Jyotirlinga for complete temple tours with flexible return schedules and reliable transportation. Perfect for multi-day religious trips, family vacations, and group pilgrimages."
  },
  {
    "name": "Private Cab for 5 Jyotirlinga Darshan",
    "description": "Choose Private Cab for 5 Jyotirlinga Darshan for personalized pilgrimage travel with dedicated vehicles and professional drivers. Enjoy privacy, comfort, flexible timings, and convenient temple visits from Navi Mumbai."
  },
  {
    "name": "Taxi Booking for Jyotirlinga Darshan Navi Mumbai",
    "description": "Complete Taxi Booking for Jyotirlinga Darshan Navi Mumbai with easy reservations and multiple vehicle options. Get reliable cab service with experienced chauffeurs for a safe and comfortable Shiva temple journey."
  },
  {
    "name": "Best Cab Service for 5 Jyotirlinga Darshan",
    "description": "Choose Best Cab Service for 5 Jyotirlinga Darshan with trusted drivers, premium vehicles, and customer-focused travel solutions. Enjoy comfortable and secure transportation for your complete Jyotirlinga pilgrimage."
  },
  {
    "name": "Innova Crysta for 5 Jyotirlinga Darshan",
    "description": "Book Innova Crysta for 5 Jyotirlinga Darshan for a premium and spacious pilgrimage experience. Enjoy luxury interiors, comfortable seating, extra luggage space, and smooth highway travel with professional chauffeurs."
  },
  {
    "name": "Ertiga Cab for Jyotirlinga Tour",
    "description": "Reserve Ertiga Cab for Jyotirlinga Tour for affordable family travel with comfortable seating and reliable service. Ideal for devotees looking for budget-friendly and convenient temple tour transportation."
  },
  {
    "name": "Tempo Traveller 5 Jyotirlinga Darshan",
    "description": "Hire Tempo Traveller 5 Jyotirlinga Darshan for group pilgrimage tours with spacious seating and comfortable travel. Choose suitable seating capacities with professional drivers for families, friends, and large groups."
  },
  {
    "name": "12 Seater Tempo Traveller Jyotirlinga",
    "description": "Book 12 Seater Tempo Traveller Jyotirlinga for comfortable group travel with ample space and modern facilities. Perfect for family groups and devotees planning a complete Jyotirlinga Yatra."
  },
  {
    "name": "17 Seater Tempo Traveller Jyotirlinga",
    "description": "Choose 17 Seater Tempo Traveller Jyotirlinga for large group pilgrimage tours with spacious interiors and experienced drivers. Enjoy convenient travel arrangements for multi-day temple journeys."
  },
  {
    "name": "Navi Mumbai to 5 Jyotirlinga Cab Fare",
    "description": "Get Navi Mumbai to 5 Jyotirlinga Cab Fare with transparent pricing and affordable travel packages. Select from Sedan, SUV, Innova, Innova Crysta, Ertiga, and Tempo Traveller options according to your group size."
  },
  {
    "name": "5 Jyotirlinga Darshan Cab Package Navi Mumbai",
    "description": "Book 5 Jyotirlinga Darshan Cab Package Navi Mumbai for customized pilgrimage tours with flexible schedules and comfortable vehicles. Enjoy complete travel solutions with professional drivers and planned routes."
  },
  {
    "name": "Affordable Jyotirlinga Cab from Navi Mumbai",
    "description": "Reserve Affordable Jyotirlinga Cab from Navi Mumbai with budget-friendly pricing and reliable transportation. Enjoy comfortable AC vehicles, experienced chauffeurs, and quality service without compromising safety."
  },
  {
    "name": "Book 5 Jyotirlinga Cab Online",
    "description": "Book 5 Jyotirlinga Cab Online with quick confirmation, easy reservations, and multiple vehicle choices. Get dependable cab services for your spiritual journey with professional driver assistance."
  },
  {
    "name": "Cheapest Cab for Jyotirlinga Darshan",
    "description": "Choose Cheapest Cab for Jyotirlinga Darshan with affordable fares and reliable travel services. Enjoy comfortable vehicles, experienced drivers, and economical options for devotees and families."
  },
  {
    "name": "Best Cab Service for 5 Jyotirlinga Darshan from Navi Mumbai",
    "description": "Select Best Cab Service for 5 Jyotirlinga Darshan from Navi Mumbai with trusted chauffeurs, clean vehicles, and flexible pilgrimage packages. Enjoy safe and comfortable travel throughout your Jyotirlinga Yatra."
  },
  {
    "name": "How to Go to 5 Jyotirlinga Darshan from Navi Mumbai by Cab",
    "description": "Plan How to Go to 5 Jyotirlinga Darshan from Navi Mumbai by Cab with comfortable private transportation and expert drivers. Get complete travel assistance, route planning, and suitable vehicle options for your pilgrimage."
  },
  {
    "name": "Navi Mumbai to Jyotirlinga Darshan Cab Package Price",
    "description": "Check Navi Mumbai to Jyotirlinga Darshan Cab Package Price with affordable and customized travel packages. Choose from different vehicle categories based on passengers, duration, and trip requirements."
  },
  {
    "name": "Family Cab for 5 Jyotirlinga Yatra from Navi Mumbai",
    "description": "Book Family Cab for 5 Jyotirlinga Yatra from Navi Mumbai with spacious vehicles, comfortable seating, and experienced drivers. Enjoy a peaceful spiritual journey with family-friendly travel facilities."
  },
  {
    "name": "Senior Citizen Friendly Jyotirlinga Darshan Cab",
    "description": "Reserve Senior Citizen Friendly Jyotirlinga Darshan Cab with comfortable vehicles, patient chauffeurs, doorstep pickup, and safe travel arrangements. Perfect for elderly devotees planning a relaxed pilgrimage."
  },
  {
    "name": "5 Jyotirlinga Darshan Cab with Driver",
    "description": "Hire 5 Jyotirlinga Darshan Cab with Driver for a convenient pilgrimage experience with professional chauffeur support. Enjoy stress-free travel, flexible timings, and comfortable journeys across temple locations."
  },
  {
    "name": "Doorstep Pickup Jyotirlinga Darshan Cab",
    "description": "Book Doorstep Pickup Jyotirlinga Darshan Cab for convenient travel from Navi Mumbai locations. Enjoy hassle-free pickup, comfortable rides, and direct transportation for your complete Shiva pilgrimage."
  },
  {
    "name": "Safe Cab for Jyotirlinga Yatra Navi Mumbai",
    "description": "Choose Safe Cab for Jyotirlinga Yatra Navi Mumbai with verified drivers, clean vehicles, and reliable travel services. Enjoy secure and comfortable transportation for your religious journey."
  },
  {
    "name": "Multi-Day Jyotirlinga Darshan Cab Package",
    "description": "Book Multi-Day Jyotirlinga Darshan Cab Package for complete pilgrimage tours with flexible schedules and comfortable vehicles. Enjoy planned routes, professional drivers, and convenient travel arrangements."
  },
  {
    "name": "Trusted Jyotirlinga Cab Service Navi Mumbai",
    "description": "Choose Trusted Jyotirlinga Cab Service Navi Mumbai for reliable and comfortable religious tour transportation. Get experienced chauffeurs, premium vehicles, transparent pricing, and dependable service for your Jyotirlinga Yatra."
  }
],
"tableData": [
  ["Navi Mumbai to 5 Jyotirlinga Darshan Cab", "5 Jyotirlinga Darshan Cab from Navi Mumbai"],
  ["Navi Mumbai 5 Jyotirlinga Yatra Cab", "5 Jyotirlinga Tour Package Navi Mumbai by Cab"],
  ["Navi Mumbai to Jyotirlinga Darshan Taxi", "5 Jyotirlinga Darshan Yatra Cab"],
  ["Jyotirlinga Darshan Cab Service Navi Mumbai", "Maharashtra 5 Jyotirlinga Darshan Cab"],
  ["Jyotirlinga Tour Cab from Navi Mumbai", "Lord Shiva Jyotirlinga Darshan Cab"],
  ["AC Cab for 5 Jyotirlinga Darshan from Navi Mumbai", "Round Trip Cab Navi Mumbai to Jyotirlinga"],
  ["Private Cab for 5 Jyotirlinga Darshan", "Taxi Booking for Jyotirlinga Darshan Navi Mumbai"],
  ["Best Cab Service for 5 Jyotirlinga Darshan", "Innova Crysta for 5 Jyotirlinga Darshan"],
  ["Ertiga Cab for Jyotirlinga Tour", "Tempo Traveller 5 Jyotirlinga Darshan"],
  ["12 Seater Tempo Traveller Jyotirlinga", "17 Seater Tempo Traveller Jyotirlinga"],
  ["Navi Mumbai to 5 Jyotirlinga Cab Fare", "5 Jyotirlinga Darshan Cab Package Navi Mumbai"],
  ["Affordable Jyotirlinga Cab from Navi Mumbai", "Book 5 Jyotirlinga Cab Online"],
  ["Cheapest Cab for Jyotirlinga Darshan", "Best Cab Service for 5 Jyotirlinga Darshan from Navi Mumbai"],
  ["How to Go to 5 Jyotirlinga Darshan from Navi Mumbai by Cab", "Navi Mumbai to Jyotirlinga Darshan Cab Package Price"],
  ["Family Cab for 5 Jyotirlinga Yatra from Navi Mumbai", "Senior Citizen Friendly Jyotirlinga Darshan Cab"],
  ["5 Jyotirlinga Darshan Cab with Driver", "Doorstep Pickup Jyotirlinga Darshan Cab"],
  ["Safe Cab for Jyotirlinga Yatra Navi Mumbai", "Multi-Day Jyotirlinga Darshan Cab Package"],
  ["Trusted Jyotirlinga Cab Service Navi Mumbai", ""]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Navi Mumbai to 5 Jyotirlinga Darshan Cab Service",
    WhyChoosedescription: "Shreesha Travels provides dedicated Navi Mumbai to 5 Jyotirlinga Darshan cab services for devotees and families planning a spiritual journey. Travel comfortably across Maharashtra and nearby states with experienced chauffeurs and reliable vehicles."
  },
  {
    WhyChooseheading: "Customized Jyotirlinga Yatra Packages",
    WhyChoosedescription: "Plan your religious tour covering major Jyotirlinga temples such as Trimbakeshwar, Bhimashankar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath with flexible routes and travel schedules."
  },
  {
    WhyChooseheading: "Spacious Vehicles for Long-Distance Pilgrimage",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles suitable for families, groups, and senior citizens."
  },
  {
    WhyChooseheading: "Ideal for Family, Group & Devotional Travel",
    WhyChoosedescription: "Our Jyotirlinga Darshan cab service is designed for families, devotees, senior citizens, and groups looking for a peaceful and comfortable temple tour experience."
  },
  {
    WhyChooseheading: "Multi-Day Cab Packages with Flexible Planning",
    WhyChoosedescription: "Book a multi-day Jyotirlinga Yatra package with flexible temple visits, overnight stays, waiting options, and customized travel plans according to your pilgrimage schedule."
  },
  {
    WhyChooseheading: "Experienced Drivers for Pilgrimage Routes",
    WhyChoosedescription: "Our professional chauffeurs have knowledge of Maharashtra temple routes and highways, ensuring safe driving, timely travel, and a smooth journey throughout the Yatra."
  },
  {
    WhyChooseheading: "Clean & Comfortable Cars for Spiritual Journeys",
    WhyChoosedescription: "Every vehicle is regularly maintained, sanitized, air-conditioned, and inspected before every trip to provide devotees with a comfortable and stress-free travel experience."
  },
  {
    WhyChooseheading: "Book Navi Mumbai to 5 Jyotirlinga Darshan Cab with Shreesha Travels",
    WhyChoosedescription: "Enjoy transparent pricing, professional chauffeur service, customized pilgrimage packages, and reliable transportation for your 5 Jyotirlinga Darshan journey from Navi Mumbai."
  }
]

};

const faqData = [
  {
    question: "Can I book a cab from Navi Mumbai for 5 Jyotirlinga Darshan?",
    answer: "Yes, you can book a private cab from Navi Mumbai for a customized 5 Jyotirlinga Darshan pilgrimage tour."
  },
  {
    question: "Which Jyotirlinga temples are covered in this tour?",
    answer: "The tour can be customized to include major Jyotirlinga temples such as Trimbakeshwar, Bhimashankar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath."
  },
  {
    question: "How many days are required for 5 Jyotirlinga Darshan?",
    answer: "The duration depends on the selected route, temple locations, sightseeing requirements, and travel schedule. Multi-day packages can be customized."
  },
  {
    question: "Which vehicles are available for Jyotirlinga Yatra?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Is this cab service suitable for senior citizens?",
    answer: "Yes, comfortable vehicles and experienced drivers make the journey convenient for senior citizens and families."
  },
  {
    question: "Can I customize the Jyotirlinga tour route?",
    answer: "Yes, you can customize temple sequence, travel duration, sightseeing stops, and stay arrangements according to your requirements."
  },
  {
    question: "Do you provide round-trip cab service for Jyotirlinga Darshan?",
    answer: "Yes, complete round-trip packages are available with pickup and drop service from Navi Mumbai."
  },
  {
    question: "How is the 5 Jyotirlinga Darshan cab fare calculated?",
    answer: "The fare depends on the selected vehicle, number of days, travel distance, route, toll charges, parking fees, driver allowance, and additional requirements."
  },
  {
    question: "Can I start the Yatra from Navi Mumbai at my preferred time?",
    answer: "Yes, pickup timing can be planned according to your convenience and temple visit schedule."
  },
  {
    question: "How can I book Navi Mumbai to 5 Jyotirlinga Darshan Cab with Shreesha Travels?",
    answer: "Share your travel dates, number of passengers, preferred vehicle, and pilgrimage requirements to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vijay Deshpande",
    feedback: "Our 5 Jyotirlinga Darshan tour from Navi Mumbai was perfectly planned. The driver was experienced with temple routes, and the journey was comfortable for our entire family.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meena Kulkarni",
    feedback: "Excellent pilgrimage cab service. The vehicle was spacious, the driver was cooperative, and we completed our temple visits comfortably without any travel worries.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to 5 Jyotirlinga Darshan Cab",
  "image": "https://www.shreeshatravels.com/assets/images/navi-mumbai-to-5-jyotirlinga-darshan-cab.webp",
  "description":
    "Book Navi Mumbai to 5 Jyotirlinga Darshan Cab with Shreesha Tours & Travels for comfortable and reliable pilgrimage taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for Jyotirlinga Yatra, religious tours, family trips, temple visits, and Maharashtra pilgrimage journeys with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/navi-mumbai-to-5-jyotirlinga-darshan-cab"
  }
};






    return (
        <div>


<Helmet>
  <title>Navi Mumbai to 5 Jyotirlinga Darshan Cab | Yatra Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Navi Mumbai to 5 Jyotirlinga Darshan Cab with Shreesha Travels for safe and comfortable pilgrimage taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for Jyotirlinga Yatra, temple visits, religious tours, family trips, and 24x7 cab booking."
  />

  <meta
    name="keywords"
    content="Navi Mumbai to 5 Jyotirlinga Darshan Cab, 5 Jyotirlinga Darshan Cab from Navi Mumbai, Navi Mumbai 5 Jyotirlinga Yatra Cab, 5 Jyotirlinga Tour Package Navi Mumbai by Cab, Navi Mumbai to Jyotirlinga Darshan Taxi, 5 Jyotirlinga Darshan Yatra Cab, Jyotirlinga Darshan Cab Service Navi Mumbai, Maharashtra 5 Jyotirlinga Darshan Cab, Jyotirlinga Yatra Taxi Navi Mumbai, Religious Tour Cab Navi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/102.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Navimumbaitofivejyotilingadarshan;